var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsaUlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 862 374",
    width: 862,
    height: 374,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.46 260.39v4.08c0 0.42-0.17 0.8-0.46 1.09q-0.51 0.45-1.26 0.46h-3.24c-0.51 0-0.93-0.17-1.22-0.46q-0.5-0.45-0.5-1.09v-4.08q-0.01-0.78 0.55-1.22c0.34-0.29 0.76-0.42 1.18-0.42h3.32c0.47 0 0.84 0.13 1.18 0.42 0.29 0.29 0.46 0.71 0.45 1.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.78 284.67v7.06c0 2.39-0.04 4.62-0.04 6.68q-0.06 3.08-0.25 4.83-0.19 0.75-0.5 1.26c-0.21 0.34-0.63 0.67-1.26 0.92q-0.56 0.2-1.64 0.34-1.06 0.07-2.4 0.21-1.38 0.11-2.77 0.17h-28.78v4.83q-0.01 2.4-0.34 4.41c-0.21 1.39-0.55 2.56-1.13 3.53q-1.45 2.63-4.16 3.7c-1.76 0.71-4.12 1.05-7.02 1.05-0.25 0-0.8 0-1.64-0.08-0.8-0.04-1.47-0.13-1.97-0.21-0.5-0.08-0.84-0.25-0.97-0.42q-0.25-0.24-0.25-0.8v-3.23c0-0.67 0.42-1.05 1.3-1.05h1.55c1.68 0 3.02-0.04 4.08-0.21 1.06-0.17 1.89-0.46 2.56-0.97 0.63-0.5 1.09-1.26 1.34-2.23 0.25-0.97 0.38-2.31 0.38-3.95v-33.28q0-0.62 0.38-1.05 0.39-0.38 0.97-0.38h3.7q0.51 0 0.88 0.38 0.38 0.43 0.38 1.05v22.48h27.9q2.2 0 2.77-0.38c0.42-0.25 0.59-1.05 0.59-2.35v-14.41q-0.06-2.52-0.13-5.42 0.01-0.63 0.34-1.01c0.21-0.29 0.55-0.42 0.92-0.42h3.61q0.68-0.01 1.05 0.42 0.38 0.38 0.38 1.01 0.06 2.52 0.13 4.28c-0.01 1.14 0.04 2.23 0.04 3.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 91.1,
    y1: 450.9,
    x2: 774.2,
    y2: -85.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.29 314.79v4.08c0 0.38-0.21 0.75-0.55 1.09-0.34 0.29-0.76 0.46-1.22 0.46h-2.9q-0.69-0.01-1.26-0.46c-0.38-0.33-0.55-0.71-0.55-1.09v-4.08c0-0.51 0.17-0.88 0.55-1.22q0.57-0.43 1.26-0.42h2.9q0.7-0.01 1.22 0.42c0.34 0.34 0.55 0.72 0.55 1.22zm-12.36 0v4.08q0.01 0.58-0.5 1.09c-0.38 0.29-0.76 0.46-1.22 0.46h-2.94c-0.51 0-0.93-0.17-1.22-0.46q-0.5-0.51-0.5-1.09v-4.08c0-0.51 0.16-0.88 0.5-1.22q0.46-0.43 1.22-0.42h2.94q0.77-0.01 1.22 0.42c0.34 0.34 0.51 0.72 0.5 1.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.24 348.84q0 1.74-0.58 2.91-0.58 1.17-1.62 1.9-1.03 0.74-2.44 1.05-1.41 0.32-3.09 0.32-0.66 0-1.44-0.04-0.77-0.04-1.32-0.1v7.75q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.49q-0.22 0-0.36-0.17-0.14-0.16-0.14-0.39v-19.23q0-0.6 0.66-0.69 0.88-0.11 2.13-0.17 1.24-0.06 2.45-0.06 1.68 0 3.09 0.32 1.41 0.32 2.44 1.02 1.04 0.71 1.62 1.85 0.58 1.15 0.58 2.8c0 0 0 0.37 0.01 0.37zm-2.51-0.36q-0.01-2.1-1.27-2.98-1.27-0.88-3.95-0.88-0.64 0-1.44 0.03-0.82 0.03-1.31 0.08v8.09q0.24 0 0.61 0.03 0.35 0.03 0.75 0.03l0.74 0.03q0.39 0.03 0.66 0.03 2.85 0 4.03-0.96 1.2-0.96 1.19-3.12v-0.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.66 362.83q0.01 0.36-0.36 0.36h-1.76q-0.25 0-0.4-0.04-0.16-0.04-0.31-0.32l-4.94-8.22h-0.72q-0.69 0-1.31-0.01-0.61-0.01-1.72-0.07v8.11q0 0.22-0.14 0.39-0.14 0.17-0.35 0.17h-1.49q-0.22 0-0.36-0.17-0.13-0.17-0.13-0.39v-19.32q0-0.3 0.13-0.43 0.14-0.12 0.53-0.18 0.45-0.06 1.03-0.1 0.59-0.04 1.25-0.07 0.65-0.03 1.31-0.04 0.65-0.01 1.26-0.01 1.63 0 3.05 0.3 1.41 0.3 2.45 0.99 1.03 0.69 1.63 1.82 0.59 1.13 0.59 2.82v0.19q0 1.16-0.32 2.08-0.32 0.93-0.89 1.61-0.58 0.69-1.38 1.16-0.8 0.47-1.74 0.72l5.02 8.39q0.06 0.16 0.07 0.26zm-3.26-14.4q0-2.07-1.32-2.87-1.33-0.8-3.92-0.8h-0.75q-0.4 0.01-0.84 0.01-0.43 0.01-0.81 0.03-0.39 0.01-0.64 0.04v7.56q0.92 0.03 1.74 0.04 0.82 0.01 1.3 0.01 1.28 0 2.25-0.18 0.99-0.18 1.64-0.62 0.66-0.45 1.01-1.17 0.34-0.74 0.34-1.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.67 362.64q0 0.22-0.14 0.39-0.14 0.17-0.35 0.17h-1.52q-0.23 0-0.36-0.17-0.14-0.17-0.14-0.39v-19.43q0-0.22 0.14-0.37 0.13-0.15 0.36-0.15h1.52q0.22 0 0.35 0.15 0.14 0.16 0.14 0.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.72 362.39q0 0.33-0.24 0.57-0.23 0.24-0.57 0.23h-1.71q-0.66 0-0.89-0.44l-8.53-16.2q-0.06-0.08-0.08-0.08-0.03 0-0.02 0.08v16.12q0 0.22-0.14 0.37-0.14 0.15-0.36 0.15h-1.44q-0.22 0-0.36-0.06-0.13-0.06-0.13-0.27v-19.4q-0.01-0.33 0.23-0.55 0.23-0.22 0.57-0.22h1.52q0.59 0 0.77 0.13 0.19 0.13 0.36 0.43l8.48 16.12 0.05 0.08q0.03 0 0.03-0.08v-16.14q0-0.22 0.13-0.37 0.14-0.15 0.36-0.15h1.46q0.23 0 0.36 0.15 0.14 0.15 0.14 0.37c0 0 0 19.16 0.01 19.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.81 224.59v4.08c0 0.42-0.17 0.75-0.55 1.09q-0.5 0.5-1.18 0.5h-2.94q-0.75 0.01-1.26-0.5c-0.29-0.33-0.46-0.67-0.46-1.09v-4.08c0-0.51 0.17-0.89 0.46-1.18q0.51-0.45 1.26-0.46h2.94c0.51 0 0.93 0.17 1.22 0.46 0.34 0.3 0.51 0.67 0.51 1.18zm12.3 0v4.08c0 0.42-0.16 0.75-0.5 1.09q-0.52 0.5-1.22 0.5h-2.94q-0.64 0.01-1.22-0.5c-0.38-0.33-0.55-0.67-0.55-1.09v-4.08q-0.01-0.76 0.55-1.18c0.38-0.29 0.8-0.46 1.22-0.46h2.94c0.46 0 0.88 0.17 1.22 0.46 0.34 0.3 0.51 0.67 0.5 1.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.66 197.41v3.82q-0.01 7.82-3.61 11.85-3.59 4.03-11.72 4.03c-2.81 0-5.29-0.42-7.39-1.18-2.14-0.8-3.82-1.97-5.08-3.57q-1.27 2.01-3.91 2.82c-1.77 0.51-3.7 0.8-5.8 0.8h-50.12q-2.35 0.01-5-0.5-2.64-0.5-4.41-1.97-1.88 1.45-4.45 1.97c-1.72 0.33-3.31 0.5-4.7 0.5h-73.65v4.79c0 1.59-0.12 3.06-0.29 4.45q-0.31 2.02-1.13 3.53-1.52 2.66-4.16 3.66-2.71 1.06-7.06 1.05-0.39 0.01-1.6-0.04c-0.84-0.08-1.52-0.12-2.02-0.25q-0.71-0.13-0.97-0.38-0.2-0.3-0.21-0.8v-3.24q0-1.06 1.26-1.05h1.6q2.45 0 4.03-0.25c1.05-0.13 1.93-0.47 2.56-0.97 0.67-0.51 1.09-1.22 1.34-2.23q0.38-1.44 0.38-3.95v-33.27q0-0.63 0.38-1.01 0.38-0.43 1.01-0.42h3.66c0.33 0 0.67 0.13 0.92 0.42q0.38 0.38 0.38 1.01v22.48h74.45q0.74-0.01 1.68-0.08 0.89-0.08 1.72-0.34 0.82-0.26 1.39-0.84 0.56-0.57 0.55-1.51v-19.7c0-0.42 0.17-0.76 0.42-1.01q0.45-0.43 1.01-0.42h3.49q0.57-0.01 1.01 0.42c0.25 0.25 0.42 0.59 0.42 1.01v20.67c0.13 0.37 0.47 0.71 0.93 0.92 0.47 0.26 1.01 0.42 1.6 0.55q0.81 0.18 1.76 0.25 0.87 0.07 1.55 0.08h51.51q0.51-0.01 1.34-0.08 0.82-0.06 1.64-0.38 0.83-0.3 1.47-0.8 0.63-0.45 0.88-1.39 0.2-0.87 0.21-2.18v-7.18q0-7.74 4.03-11.89c2.69-2.78 6.51-4.12 11.51-4.12q7.56 0 11.34 4.03c2.57 2.73 3.87 6.68 3.85 11.89zm-6.32 0.66c0-3.4-0.64-6.05-1.98-7.9-1.34-1.85-3.61-2.77-6.89-2.77-3.28 0-5.67 0.92-7.1 2.73q-2.14 2.77-2.14 7.94v3.32c0 1.6 0.12 2.99 0.29 4.12 0.51 2.18 1.52 3.69 3.03 4.45q2.27 1.19 5.8 1.18c3.32 0 5.63-0.8 6.97-2.35q2.02-2.39 2.02-7.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.67 210.85q0-1.35 1.43-1.35h27.13q2.18 0 2.82-0.38 0.64-0.38 0.64-2.33v-45.85q0-0.6 0.37-1.05 0.37-0.45 0.98-0.45h3.84q0.59 0 0.94 0.45 0.34 0.45 0.34 1.05v43.37q0 3.09-0.07 5.11-0.07 2.02-0.22 3.61-0.16 0.75-0.45 1.28-0.31 0.52-1.21 0.9-0.6 0.22-1.73 0.34-1.13 0.11-2.55 0.23-1.43 0.12-2.93 0.15-1.51 0.03-2.93 0.04h-24.95q-1.43 0-1.43-1.28v-3.84zm8.18-50.21q-1.35 0-1.35-0.9v-1.28q0-0.75 1.35-0.75h1.28q-0.68-0.82-0.98-1.99-0.31-1.17-0.3-2.29 0-3.16 1.84-4.62 1.84-1.46 5.23-1.46 0.6 0 1.35 0.07 0.75 0.08 1.5 0.23 0.83 0.3 0.83 0.9v1.05q0 0.83-0.98 0.83-0.16 0-1.06-0.04-0.91-0.03-1.27-0.04-3.99 0-3.99 3.38 0 1.58 0.53 2.59 0.53 1.02 1.13 1.31h5.04q1.28 0 1.28 0.9v1.2q0 0.6-0.34 0.75-0.34 0.15-0.94 0.15h-10.15zm1.88 7.14q0-0.6 0.41-1.05 0.42-0.45 1.02-0.45h3.61q0.59 0 0.94 0.45 0.34 0.45 0.34 1.05v33.52q0 1.43-1.35 1.43h-3.53q-1.43 0-1.43-1.43c0 0 0-33.52-0.01-33.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272.37 160.94q0-0.6 0.41-1.05 0.42-0.45 1.02-0.45h3.68q0.6 0 0.98 0.45 0.38 0.45 0.38 1.05v53.51q0 0.6-0.38 1.05-0.37 0.45-0.98 0.45h-3.68q-0.6 0-1.02-0.45-0.41-0.45-0.41-1.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.09 167.24v4.08c0 0.46-0.21 0.84-0.55 1.13-0.34 0.29-0.76 0.46-1.22 0.46h-2.9q-0.69-0.01-1.26-0.46-0.56-0.44-0.55-1.13v-4.08c0-0.47 0.17-0.89 0.55-1.18q0.57-0.45 1.26-0.46h2.9c0.46 0 0.88 0.17 1.22 0.46 0.34 0.3 0.55 0.72 0.55 1.18zm-12.35 0v4.08q0.01 0.69-0.5 1.13c-0.38 0.29-0.76 0.46-1.22 0.46h-2.94c-0.51 0-0.93-0.17-1.22-0.46q-0.5-0.44-0.5-1.13v-4.08c0-0.47 0.16-0.89 0.5-1.18 0.3-0.29 0.72-0.46 1.22-0.46h2.94q0.75 0.01 1.26 0.46c0.29 0.3 0.46 0.72 0.46 1.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m491.24 197.4v3.82q0.01 7.81-3.57 11.85-3.64 4.03-11.76 4.03c-2.77 0-5.25-0.42-7.39-1.18-2.14-0.8-3.82-1.97-5.08-3.57q-1.26 2.01-3.91 2.82c-1.73 0.51-3.66 0.8-5.76 0.8h-110.71q-3.39 0-5.71-1.01-2.28-0.95-3.49-3.36c-0.84 1.09-2.14 1.89-3.95 2.35-1.77 0.5-3.7 0.71-5.8 0.71h-0.67c-4.67 0-8.28-1.26-10.76-3.82q-3.78-3.83-3.78-11.13v-1.93c0-2.98 0.51-5.5 1.43-7.6q1.44-3.17 4.03-5.13 2.59-2 6.18-2.94c2.36-0.63 5-0.97 7.86-0.97 0.63 0 1.39 0.04 2.23 0.08 0.88 0.04 1.68 0.12 2.52 0.25q1.26 0.14 2.39 0.34c0.71 0.13 1.38 0.25 1.93 0.38q0.75 0.18 0.93 0.5c0.17 0.21 0.21 0.54 0.21 0.92v21.13q-0.01 3.04 1.43 3.87 1.43 0.88 3.82 0.88h78.02l-7.06-18.07c-0.08-0.13-0.17-0.34-0.21-0.59 0-0.25-0.04-0.46-0.04-0.67l0.08-2.18c0.08-0.63 0.5-1.3 1.3-1.93q1.26-1.15 3.02-2.1c1.17-0.58 2.47-1.13 3.86-1.55 1.43-0.42 2.85-0.76 4.37-1.01q2.29-0.38 4.5-0.38 3.72-0.01 6.81 0.8c2.1 0.59 3.87 1.43 5.38 2.61q2.27 1.77 3.53 4.54c0.8 1.89 1.22 4.08 1.22 6.64v1.43c0 1.18-0.13 2.44-0.38 3.7-0.25 1.22-0.59 2.44-1.05 3.53q-0.71 1.72-1.6 3.11-0.95 1.38-2.1 2.14h11.43c0.37 0 0.79-0.04 1.34-0.08q0.87-0.06 1.68-0.38c0.54-0.21 1.05-0.46 1.47-0.8q0.64-0.45 0.84-1.39 0.25-0.87 0.25-2.18v-7.18c0-5.17 1.3-9.12 3.99-11.89 2.68-2.78 6.55-4.12 11.55-4.12q7.5 0 11.34 4.03c2.56 2.73 3.82 6.68 3.84 11.88zm-158.95-10c-1.01-0.12-1.89-0.17-2.65-0.25q-1.15-0.05-2.1-0.04-2.71-0.01-4.96 0.42c-1.52 0.34-2.82 0.84-3.87 1.64q-1.62 1.14-2.56 3.15c-0.63 1.34-0.92 2.98-0.92 5v1.6q0 4.49 2.02 7.02 2.01 2.52 6.93 2.52h1.43c0.71 0 1.51-0.04 2.31-0.17q1.18-0.14 2.18-0.59c0.63-0.29 1.17-0.71 1.55-1.26q0.63-0.77 0.63-1.98c0.01 0 0.01-17.06 0.01-17.06zm110.07 8.96c0-3.31-0.93-5.71-2.86-7.18q-2.83-2.22-7.81-2.23-1.96-0.01-5 0.55-3.1 0.5-5.88 2.39l7.69 19.7h5.55c2.6-0.63 4.66-2.06 6.13-4.37q2.19-3.47 2.18-8.07zm42.55 1.71c0-3.4-0.67-6.05-1.97-7.9q-2.02-2.77-6.89-2.77-4.97 0.01-7.1 2.73-2.14 2.77-2.14 7.94v3.32c0 1.6 0.08 2.99 0.29 4.12 0.5 2.18 1.51 3.69 3.02 4.45 1.47 0.8 3.41 1.18 5.76 1.18 3.32 0 5.68-0.8 7.02-2.35q2.02-2.39 2.02-7.94c-0.01 0-0.01-2.78-0.01-2.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m538.15 224.59v4.08c0 0.42-0.21 0.76-0.55 1.09q-0.52 0.5-1.22 0.5h-3.19q-0.7 0.01-1.22-0.5c-0.34-0.33-0.55-0.67-0.55-1.09v-4.08c0-0.51 0.21-0.89 0.55-1.18 0.34-0.29 0.76-0.46 1.22-0.46h3.19c0.46 0 0.88 0.17 1.22 0.46 0.34 0.3 0.55 0.67 0.55 1.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.73 211.44v2.73q0.01 0.82-0.42 1.3-0.45 0.51-1.72 0.5h-42.85c-1.6 0-2.98-0.17-4.2-0.42q-1.82-0.44-3.07-1.51-1.31-1.07-1.93-2.9-0.63-1.77-0.63-4.66v-45.54c0-0.38 0.13-0.76 0.38-1.05q0.43-0.45 1.05-0.46h3.65c0.42 0 0.71 0.17 1.01 0.46 0.21 0.29 0.38 0.67 0.38 1.05v44.11c0 1.01 0.08 1.81 0.34 2.4 0.21 0.55 0.55 1.01 0.97 1.3 0.42 0.29 0.92 0.5 1.55 0.59q0.94 0.18 2.14 0.17h36.3l-2.69-6.47-1.72-3.99c-1.68-3.78-3.86-6.64-6.6-8.53q-4.09-2.83-11.13-2.82c-0.21 0-0.55 0-0.97 0.04-0.42 0.04-0.88 0.04-1.43 0.13-0.5 0.04-1.05 0.08-1.55 0.08q-0.82 0.06-1.39 0.13c-1.13 0.08-1.68-0.25-1.68-1.05v-3.07c0-0.42 0.13-0.71 0.29-0.97q0.32-0.33 1.13-0.46c1.13-0.25 2.35-0.46 3.74-0.55 1.39-0.08 2.52-0.17 3.4-0.17q3.78 0.01 7.06 0.71c2.23 0.5 4.28 1.39 6.26 2.65 1.93 1.3 3.74 3.02 5.42 5.25 1.64 2.23 3.19 5.13 4.66 8.61l0.76 1.97 3.15 8.02c0.08 0.34 0.17 0.71 0.25 1.05 0.09 0.36 0.09 0.82 0.09 1.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.04 260.39v4.08q0.01 0.64-0.5 1.09c-0.3 0.29-0.72 0.46-1.22 0.46h-3.24q-0.75-0.01-1.26-0.46c-0.29-0.29-0.46-0.67-0.46-1.09v-4.08q0-0.78 0.5-1.22c0.38-0.29 0.76-0.42 1.22-0.42h3.32c0.42 0 0.84 0.13 1.13 0.42q0.5 0.45 0.51 1.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.71 251.15v45.37c0 0.75 0 1.55-0.04 2.35 0 0.8-0.04 1.55-0.08 2.31-0.08 0.76-0.12 1.43-0.25 2.06-0.08 0.5-0.25 0.92-0.42 1.26-0.21 0.33-0.63 0.67-1.22 0.92-0.42 0.13-0.96 0.26-1.72 0.34-0.76 0.04-1.6 0.13-2.48 0.21-0.93 0.09-1.85 0.13-2.82 0.17h-56.05v4.83q0.01 2.4-0.29 4.41-0.31 2.08-1.13 3.53-1.52 2.65-4.16 3.7c-1.81 0.71-4.12 1.05-7.02 1.05-0.3 0-0.8 0-1.64-0.08-0.84-0.04-1.51-0.13-1.97-0.21-0.51-0.08-0.84-0.25-1.01-0.42q-0.2-0.24-0.21-0.8v-3.23c0-0.67 0.42-1.05 1.26-1.05h1.6c1.64 0 2.99-0.04 4.08-0.21 1.01-0.17 1.89-0.47 2.52-0.97q1.01-0.77 1.34-2.23c0.3-0.97 0.38-2.31 0.38-3.95v-33.28q0-0.62 0.38-1.05 0.38-0.38 1.01-0.38h3.66q0.55 0 0.92 0.38 0.38 0.43 0.38 1.05v22.48h18.57l-7.1-18.07c-0.09-0.13-0.13-0.34-0.17-0.59q-0.05-0.37-0.04-0.67l0.08-2.18c0.04-0.68 0.46-1.31 1.26-1.98 0.89-0.76 1.89-1.43 3.07-2.06q1.78-0.93 3.87-1.55 2.09-0.68 4.37-1.05c1.51-0.21 2.98-0.38 4.49-0.38 2.44 0 4.75 0.29 6.81 0.84 2.1 0.55 3.87 1.43 5.38 2.61 1.51 1.18 2.65 2.69 3.49 4.54q1.26 2.79 1.26 6.64v1.43q0 1.76-0.38 3.65c-0.25 1.26-0.63 2.44-1.05 3.57-0.46 1.14-1.01 2.14-1.64 3.11q-0.93 1.39-2.06 2.14h15.04q2.15 0 2.73-0.38c0.38-0.25 0.55-1.05 0.55-2.35v-45.84c0-0.42 0.17-0.76 0.42-1.01q0.44-0.43 1.01-0.42h3.7c0.42 0 0.72 0.13 0.97 0.42q0.38 0.37 0.35 1.02zm-25.91 35.38c0-3.27-0.97-5.67-2.86-7.14-1.89-1.52-4.49-2.23-7.81-2.23q-1.95 0-5.04 0.5c-2.06 0.38-3.99 1.18-5.84 2.44l7.65 19.66h5.55c2.64-0.59 4.66-2.06 6.13-4.33 1.52-2.31 2.23-5 2.23-8.07-0.01 0-0.01-0.83-0.01-0.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.52 251.13q0-0.6 0.41-1.05 0.42-0.45 1.02-0.45h3.68q0.59 0 0.98 0.45 0.38 0.45 0.38 1.05v53.51q0 0.6-0.38 1.05-0.37 0.45-0.98 0.45h-3.68q-0.6 0-1.02-0.45-0.41-0.45-0.41-1.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272.96 300.97v3.99q0.01 0.57-0.42 0.88c-0.34 0.21-0.67 0.29-1.05 0.29h-33.4c-1.55 0-3.19-0.13-5-0.46-1.76-0.34-3.24-1.01-4.37-2.02q-1.9 1.51-4.5 2.02c-1.72 0.34-3.28 0.46-4.7 0.46h-33.82c-0.38 0-0.76-0.08-1.05-0.34-0.29-0.21-0.46-0.5-0.46-0.92v-3.82q0.01-0.63 0.46-1.01c0.29-0.21 0.67-0.34 1.05-0.34h20.54l-0.08-9.24c-0.13-4.41-1.22-7.73-3.32-9.87-2.1-2.14-5.55-3.24-10.29-3.24-0.55 0-1.34 0.04-2.35 0.04-1.05 0.04-1.93 0.08-2.69 0.21q-1.51 0.13-1.51-1.05v-3.11q0.01-0.58 0.34-0.97c0.25-0.25 0.63-0.42 1.18-0.46q1.96-0.32 3.74-0.38 1.76-0.07 2.56-0.08 5.04 0 8.57 1.39c2.4 0.88 4.29 2.18 5.71 3.82 1.47 1.64 2.52 3.61 3.19 5.84 0.67 2.27 1.09 4.75 1.18 7.48l0.08 9.62h7.9q0.75-0.01 1.64-0.08c0.59-0.04 1.18-0.17 1.72-0.34q0.82-0.26 1.39-0.84c0.38-0.38 0.59-0.88 0.59-1.55v-19.66q-0.01-0.62 0.42-1.05 0.38-0.38 1.01-0.38h3.44q0.63 0 1.01 0.38 0.43 0.43 0.42 1.05v20.67c0.17 0.38 0.46 0.71 0.92 0.92 0.5 0.21 1.01 0.42 1.6 0.5 0.59 0.13 1.18 0.25 1.77 0.29q0.89 0.07 1.6 0.08h10.04c-0.97-1.13-1.77-2.65-2.35-4.62-0.59-1.93-0.88-4.28-0.88-6.97v-0.84q0.01-3.98 1.34-6.93 1.32-2.96 3.65-4.92 2.39-1.95 5.59-2.9c2.1-0.63 4.45-0.97 6.93-0.97q1.51 0.01 3.28 0.08c1.18 0.04 2.61 0.21 4.24 0.46 0.55 0.08 0.97 0.25 1.3 0.42q0.43 0.25 0.42 1.01v3.02q0 0.81-0.5 1.05c-0.38 0.21-0.71 0.25-1.13 0.21q-1.9-0.14-3.4-0.21c-0.97-0.08-2.14-0.08-3.45-0.08-3.7 0-6.64 0.8-8.74 2.44q-3.2 2.45-3.19 7.98v0.92c0 2.65 0.5 5 1.51 6.97 1.05 2.02 2.27 3.28 3.74 3.87h15.12c0.38 0 0.71 0.08 1.05 0.34 0.29 0.23 0.41 0.53 0.41 0.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.88 314.79v4.08q0.01 0.58-0.55 1.09c-0.34 0.29-0.76 0.46-1.18 0.46h-3.24c-0.46 0-0.88-0.17-1.22-0.46-0.34-0.33-0.55-0.71-0.55-1.09v-4.08c0-0.51 0.21-0.88 0.55-1.22q0.52-0.43 1.22-0.42h3.24c0.42 0 0.84 0.13 1.18 0.42 0.37 0.34 0.54 0.72 0.55 1.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.52 265.26v4.08c0 0.46-0.16 0.79-0.5 1.13q-0.46 0.43-1.22 0.42h-3.23q-0.75 0.01-1.26-0.42c-0.29-0.33-0.46-0.67-0.46-1.13v-4.08q0-0.75 0.5-1.18c0.38-0.33 0.76-0.46 1.22-0.46h3.32c0.42 0 0.84 0.12 1.13 0.46q0.51 0.43 0.5 1.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357.74 284.67v7.06q0.01 3.59-0.04 6.68 0 3.08-0.25 4.83-0.12 0.75-0.5 1.26c-0.21 0.34-0.63 0.67-1.22 0.92q-0.63 0.2-1.64 0.34c-0.71 0.04-1.51 0.13-2.44 0.21q-1.33 0.11-2.77 0.17h-12.6v5.34c0 0.92-0.04 1.81-0.04 2.65-0.04 0.84-0.08 1.6-0.13 2.18 0 0.8-0.55 1.3-1.6 1.55q-2.82 0.63-5.84 0.88-3.04 0.25-6.01 0.25c-4.37 0-8.03-0.46-11.01-1.47-2.98-0.97-5.42-2.4-7.23-4.29q-2.76-2.9-3.95-7.06c-0.8-2.77-1.22-5.92-1.22-9.5q0.01-0.68 0.08-1.93 0.07-1.2 0.21-2.65c0.04-0.97 0.17-1.89 0.25-2.81 0.08-0.92 0.21-1.76 0.38-2.44q0.13-0.82 0.46-1.13c0.17-0.21 0.55-0.29 1.05-0.29h3.15q1.2 0.01 1.13 1.47c-0.08 0.63-0.13 1.26-0.21 1.93q-0.12 1-0.17 2.02c-0.08 0.67-0.08 1.34-0.13 1.93-0.05 0.59-0.04 1.09-0.04 1.51q0.01 3.89 0.59 7.23 0.5 3.34 2.4 5.8 1.84 2.45 5.25 3.82c2.27 0.92 5.34 1.39 9.12 1.39 1.3 0 2.52 0 3.57-0.04 1.09-0.08 2.27-0.21 3.49-0.46 0-1.34 0.04-2.56 0.04-3.65q0.05-1.64 0.04-3.03v-28.11c0-0.42 0.17-0.76 0.42-1.05q0.43-0.38 0.93-0.38h3.7q0.62 0 0.92 0.38 0.38 0.43 0.38 1.05v22.48h11.76q2.2 0 2.82-0.38c0.38-0.25 0.59-1.05 0.59-2.35v-9.62q0.01-2.33-0.04-4.79c-0.04-1.68-0.04-3.49-0.13-5.42q0.01-0.63 0.34-1.01c0.25-0.29 0.55-0.42 0.97-0.42h3.61c0.42 0 0.8 0.13 1.05 0.42q0.38 0.38 0.38 1.01 0.07 2.52 0.08 4.28 0.06 1.72 0.05 3.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m352.12 314.79v4.08q0.01 0.58-0.55 1.09c-0.34 0.29-0.72 0.46-1.18 0.46h-3.24c-0.46 0-0.84-0.17-1.22-0.46q-0.5-0.51-0.5-1.09v-4.08c0-0.51 0.16-0.88 0.5-1.22 0.38-0.29 0.76-0.42 1.22-0.42h3.24c0.47 0 0.84 0.13 1.18 0.42 0.38 0.34 0.54 0.72 0.55 1.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m386.24 306.68q0-4.8 2.03-6.99 2.03-2.18 5.79-2.48-0.52-1.2-0.71-2.97-0.19-1.77-0.19-3.5v-3.91q0.01-7.74 4.02-11.91 4.02-4.17 11.54-4.17 7.44 0 11.32 4.09 3.87 4.1 3.87 11.91v4.14q0 7.81-3.73 11.8-3.72 3.98-11.68 3.98-3.91 0-6.8-0.9-2.89-0.9-4.78-2.86-2.25 0-3.34 0.75-1.09 0.75-1.09 3.38v16.68q0.01 0.6-0.38 1.02-0.37 0.41-0.98 0.41h-3.53q-0.6 0-0.98-0.41-0.38-0.42-0.38-1.02zm13.23-16.24q0 5.49 1.99 7.89 1.99 2.4 7.02 2.4 4.97 0 7.02-2.37 2.07-2.37 2.07-7.93v-3.16q0-5.19-1.99-7.89-1.98-2.7-6.95-2.71-4.96 0-7.07 2.71-2.11 2.72-2.1 7.89v3.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.61 283.76v12.73c0 0.72 0 1.51-0.04 2.27q-0.07 1.18-0.13 2.31-0.07 1.14-0.13 2.02-0.18 0.82-0.5 1.34-0.31 0.55-1.26 0.92c-0.76 0.26-1.89 0.42-3.32 0.55q-2.14 0.2-4.54 0.21h-1.22q-2.71-0.01-5.42-0.46-2.7-0.45-4.66-1.97-1.51 1.32-3.78 1.89c-1.52 0.42-3.15 0.59-4.92 0.59h-1.26c-1.6 0-3.15-0.12-4.75-0.46q-2.39-0.51-4.16-2.02c-1.18 1.01-2.65 1.68-4.33 2.02-1.73 0.33-3.37 0.46-4.92 0.46h-63.06q-2.38 0-4.2-0.38c-1.18-0.29-2.23-0.8-3.07-1.51-0.84-0.76-1.51-1.72-1.93-2.9q-0.63-1.83-0.63-4.66v-45.54q-0.01-0.62 0.42-1.05 0.38-0.45 1.01-0.46h3.7c0.38 0 0.72 0.17 0.97 0.46q0.38 0.43 0.38 1.05v44.11q0.01 1.52 0.34 2.35c0.21 0.58 0.55 1 0.97 1.34 0.42 0.3 0.97 0.51 1.6 0.59 0.63 0.09 1.34 0.17 2.14 0.17h10.97v-48.57q0-0.63 0.38-1.01 0.4-0.43 0.97-0.42h3.7q0.57-0.01 1.01 0.42c0.25 0.25 0.42 0.59 0.42 1.01v24.79c1.31-0.93 2.73-1.72 4.33-2.27 1.55-0.58 3.15-1 4.66-1.34 1.56-0.3 3.03-0.51 4.33-0.59 1.35-0.09 2.44-0.17 3.28-0.17q4.79 0.01 8.57 1.09 3.78 1.02 6.3 3.36 2.59 2.32 3.91 5.97 1.39 3.67 1.39 8.91v1.22c0 0.55-0.04 1.18-0.04 1.89q-0.07 1.13-0.13 2.14-0.07 1.08-0.21 2.02-0.19 0.93-0.38 1.55h8.57c0.46 0 1.05-0.04 1.64-0.08 0.59-0.05 1.18-0.17 1.68-0.34 0.54-0.17 0.96-0.46 1.34-0.84q0.58-0.55 0.59-1.55v-16.22q0-0.62 0.38-1.05c0.26-0.29 0.55-0.46 0.97-0.46h3.45q0.63 0.01 1.01 0.46 0.38 0.43 0.38 1.05v17.35c0.12 0.42 0.46 0.72 0.92 0.97 0.46 0.21 1 0.37 1.55 0.5q0.88 0.18 1.81 0.25c0.58 0.08 1.09 0.08 1.55 0.08h1.68q0.63-0.01 1.51-0.13c0.59-0.04 1.1-0.17 1.6-0.38q0.7-0.25 1.22-0.76c0.34-0.38 0.55-0.84 0.55-1.43v-19.03q-0.01-0.57 0.42-1.01 0.38-0.43 1.01-0.42h3.45c0.42 0 0.72 0.13 0.97 0.42q0.38 0.44 0.38 1.01v19.91c0.16 0.42 0.46 0.72 0.92 0.97q0.64 0.31 1.6 0.5 0.95 0.18 2.02 0.25c0.68 0.08 1.35 0.08 2.02 0.08h2.4q1.14 0.01 1.77-0.04c0.42 0 0.76-0.12 1.01-0.29q0.38-0.24 0.5-0.8c0.09-0.33 0.13-0.88 0.13-1.55v-10.63c0-3.57-0.09-7.35-0.17-11.26q0-0.57 0.38-1.01 0.4-0.43 0.97-0.42h3.53q0.68-0.01 1.05 0.42 0.38 0.44 0.38 1.01 0.07 2.58 0.13 4.58 0.08 2.01-0.03 3.92zm-62.78 8.26c0-2.77-0.29-5.04-0.92-6.89q-0.94-2.73-2.77-4.37c-1.26-1.13-2.77-1.89-4.62-2.31-1.85-0.42-4.03-0.63-6.47-0.63-0.84 0-1.98 0.04-3.32 0.17q-2 0.15-4.2 0.59c-1.47 0.3-2.9 0.72-4.37 1.18q-2.16 0.76-3.74 1.97v17.98q1.88 0.05 3.82 0.04h24.66c0.71 0 1.18-0.42 1.47-1.22 0.33-0.84 0.46-2.56 0.46-5.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.95 362.47q0 0.25-0.17 0.37-0.17 0.12-0.39 0.18-0.45 0.09-0.88 0.15-0.45 0.07-0.97 0.11-0.53 0.04-1.19 0.07-0.66 0.03-1.54 0.03-1.27 0-2.57-0.39-1.29-0.39-2.35-1.37-1.04-0.98-1.71-2.62-0.66-1.65-0.66-4.15v-3.84q0-2.54 0.66-4.18 0.66-1.63 1.71-2.61 1.06-0.97 2.35-1.35 1.3-0.39 2.57-0.39 1.33 0 2.53 0.15 1.2 0.15 2.11 0.29 0.45 0.06 0.44 0.36v1.41q0 0.14-0.06 0.22-0.05 0.08-0.28 0.08h-0.08l-0.91-0.08q-0.55-0.03-1.17-0.07-0.62-0.04-1.28-0.07-0.66-0.03-1.27-0.03-1.01 0-1.89 0.32-0.87 0.31-1.52 1.05-0.64 0.73-1.02 1.93-0.38 1.2-0.38 2.97v3.84q0 1.74 0.38 2.94 0.37 1.2 1.02 1.93 0.65 0.73 1.52 1.06 0.87 0.33 1.89 0.33 0.58 0 1.25-0.03l1.26-0.06q0.62-0.03 1.13-0.07 0.53-0.04 0.91-0.07h0.11q0.45 0 0.44 0.44c0 0 0 1.15 0.01 1.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.59 362.86q0 0.13-0.07 0.25-0.07 0.12-0.21 0.14-0.39 0.06-1.05 0.07-0.67 0.01-1.42 0.04-0.77 0.03-1.53 0.03h-1.38q-2.93 0-4.4-1.19-1.47-1.19-1.48-3.95v-10.63q0-2.77 1.48-3.94 1.47-1.19 4.4-1.19 0.6 0 1.35 0l1.52 0.06q0.74 0 1.4 0.06l1.11 0.06q0.14 0.02 0.21 0.14 0.07 0.12 0.07 0.25v1.38q0 0.33-0.3 0.33h-5.33q-1.1 0-1.76 0.15-0.66 0.15-1.02 0.5-0.37 0.34-0.48 0.9-0.12 0.55-0.12 1.32v3.84h8.47q0.23 0 0.39 0.17 0.16 0.16 0.16 0.39v1.05q0 0.22-0.16 0.39-0.17 0.17-0.39 0.17h-8.47v4.64q0 0.8 0.12 1.34 0.12 0.54 0.48 0.88 0.35 0.35 1.02 0.5 0.67 0.15 1.76 0.15h5.33q0.31 0 0.3 0.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m125.73 357.86q0 0.99-0.3 1.99-0.31 0.99-1.07 1.78-0.76 0.79-2.08 1.27-1.32 0.48-3.36 0.48-1.47 0-2.57-0.12-1.1-0.12-2.01-0.26-0.36-0.05-0.44-0.17-0.09-0.1-0.08-0.33v-1.1q0-0.22 0.14-0.33 0.13-0.11 0.33-0.11h0.08q0.46 0.06 1.07 0.08 0.59 0.03 1.2 0.06l1.21 0.03q0.6 0 1.07 0 1.25 0 2.06-0.23 0.81-0.24 1.28-0.66 0.46-0.43 0.66-1.04 0.18-0.61 0.19-1.32 0-0.53-0.16-0.95-0.17-0.43-0.55-0.84-0.38-0.41-1.03-0.87-0.63-0.46-1.57-1.03l-2.68-1.63q-1.9-1.16-2.86-2.33-0.95-1.17-0.95-2.83 0-2.51 1.71-3.7 1.71-1.19 4.88-1.19 0.61 0 1.29 0.03 0.67 0.03 1.32 0.07 0.65 0.05 1.23 0.11 0.58 0.07 0.96 0.13 0.48 0.08 0.48 0.47v1.19q0 0.44-0.48 0.44h-0.05q-0.92-0.06-2.22-0.11-1.31-0.06-2.53-0.06-2.16 0-3.1 0.55-0.95 0.55-0.95 2.07 0 0.97 0.71 1.68 0.72 0.72 2.29 1.66l2.54 1.52q1.18 0.72 2.01 1.38 0.84 0.66 1.35 1.33 0.52 0.66 0.75 1.38 0.24 0.68 0.23 1.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.28 362.75q0 0.44-0.48 0.44h-1.62q-0.19 0-0.3-0.13-0.11-0.12-0.16-0.29l-1.8-6.35h-7.15l-1.76 6.35q-0.06 0.17-0.2 0.29-0.13 0.13-0.3 0.13h-1.62q-0.47 0-0.47-0.44 0-0.14 0.02-0.19l5.1-17.97q0.17-0.63 0.48-1.04 0.32-0.41 0.71-0.63 0.39-0.23 0.81-0.33 0.43-0.09 0.81-0.1 0.39 0 0.8 0.08 0.41 0.08 0.8 0.32 0.38 0.24 0.71 0.64 0.32 0.4 0.48 1.03l5.1 18q0.05 0.05 0.04 0.19zm-7.4-17.58q-0.13-0.5-0.53-0.5-0.41 0-0.55 0.5l-2.51 9.08h6.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.91 344.4q0.01 0.44-0.53 0.44h-5.37v17.8q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.51q-0.22 0-0.36-0.17-0.13-0.17-0.13-0.39v-17.8h-5.38q-0.23 0-0.39-0.11-0.17-0.1-0.17-0.33v-1.21q0-0.23 0.17-0.36 0.17-0.14 0.39-0.14h13.27q0.53 0 0.53 0.5v1.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.19 344.4q0 0.44-0.53 0.44h-5.37v17.8q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.52q-0.22 0-0.36-0.17-0.13-0.17-0.13-0.39v-17.8h-5.38q-0.22 0-0.39-0.11-0.17-0.1-0.17-0.33v-1.21q0-0.23 0.17-0.36 0.17-0.14 0.39-0.14h13.27q0.53 0 0.53 0.5c0 0 0 1.21-0.01 1.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.35 362.75q0 0.44-0.47 0.44h-1.62q-0.2 0-0.3-0.13-0.11-0.12-0.17-0.29l-1.79-6.35h-7.15l-1.77 6.35q-0.05 0.17-0.19 0.29-0.14 0.13-0.3 0.13h-1.63q-0.47 0-0.47-0.44 0-0.14 0.03-0.19l5.1-17.97q0.16-0.63 0.48-1.04 0.31-0.41 0.7-0.63 0.39-0.24 0.82-0.33 0.42-0.09 0.81-0.1 0.38 0 0.8 0.08 0.42 0.08 0.8 0.32 0.38 0.24 0.71 0.64 0.31 0.4 0.48 1.03l5.1 18q0.03 0.05 0.03 0.19zm-7.39-17.58q-0.14-0.5-0.53-0.5-0.42 0-0.55 0.5l-2.51 9.08h6.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.03 362.64q-0.01 0.22-0.16 0.39-0.17 0.17-0.39 0.17h-1.35q-0.23 0-0.39-0.17-0.17-0.17-0.17-0.39v-16.37q0-0.09-0.02-0.08-0.02 0-0.06 0.06l-3.95 8.17q-0.22 0.41-0.47 0.61-0.24 0.19-0.77 0.19h-1.27q-0.52 0-0.77-0.19-0.24-0.19-0.47-0.61l-3.95-8.17q-0.03-0.06-0.06-0.06-0.03 0-0.02 0.08v16.37q-0.01 0.22-0.16 0.39-0.17 0.17-0.39 0.17h-1.35q-0.23 0-0.39-0.17-0.16-0.17-0.16-0.39v-19.15q-0.01-0.33 0.23-0.57 0.23-0.24 0.57-0.24h1.8q0.37 0 0.57 0.1 0.17 0.1 0.31 0.37l4.55 9.47q0.14 0.3 0.34 0.3 0.19 0 0.33-0.3l4.55-9.47q0.14-0.27 0.32-0.37 0.16-0.09 0.57-0.1h1.79q0.33 0 0.57 0.24 0.24 0.23 0.24 0.57v19.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.59 357.53q0 1.74-0.65 2.87-0.65 1.13-1.76 1.79-1.12 0.66-2.58 0.92-1.47 0.26-3.07 0.26-1.37 0-2.54-0.06-1.17-0.06-1.96-0.19-0.47-0.06-0.69-0.27-0.22-0.22-0.22-0.75v-18.38q0-0.95 0.89-1.02 0.68-0.09 1.86-0.15 1.17-0.07 2.52-0.07 1.66 0 3.13 0.25 1.46 0.25 2.56 0.86 1.1 0.61 1.76 1.63 0.65 1.01 0.65 2.6v0.44q0 1.55-0.77 2.66-0.78 1.11-2.18 1.67 1.44 0.49 2.25 1.68 0.81 1.18 0.81 2.79c0 0 0 0.47-0.01 0.47zm-2.62-9.71q0-0.99-0.4-1.61-0.39-0.62-1.13-0.98-0.72-0.36-1.75-0.48-1.01-0.12-2.3-0.13-0.71 0-1.43 0.03-0.72 0.03-1.3 0.05v6.85h4.24q1.19 0 1.98-0.26 0.79-0.25 1.26-0.72 0.47-0.45 0.65-1.05 0.18-0.59 0.18-1.26zm0.11 9.24q-0.01-0.69-0.19-1.32-0.19-0.64-0.68-1.12-0.48-0.48-1.28-0.77-0.8-0.29-2.02-0.29h-4.24v7.59q0.69 0.03 1.42 0.07 0.73 0.04 1.44 0.04 1.28-0.01 2.31-0.16 1.03-0.16 1.76-0.58 0.72-0.41 1.1-1.13 0.39-0.72 0.39-1.85v-0.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m238.91 362.64q0 0.22-0.14 0.39-0.14 0.17-0.35 0.17h-1.52q-0.22 0-0.36-0.17-0.14-0.17-0.14-0.39v-19.43q0-0.22 0.14-0.37 0.13-0.15 0.36-0.15h1.52q0.22 0 0.35 0.15 0.15 0.16 0.14 0.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.95 362.39q0 0.33-0.24 0.57-0.23 0.24-0.57 0.23h-1.71q-0.66 0-0.89-0.44l-8.53-16.2q-0.06-0.08-0.08-0.08-0.02 0-0.02 0.08v16.12q0 0.22-0.14 0.37-0.14 0.15-0.36 0.15h-1.44q-0.22 0-0.36-0.06-0.13-0.06-0.13-0.27v-19.4q0-0.33 0.23-0.55 0.23-0.22 0.57-0.22h1.52q0.59 0 0.77 0.13 0.2 0.13 0.36 0.43l8.48 16.12 0.05 0.08q0.03 0 0.03-0.08v-16.14q0-0.22 0.13-0.37 0.14-0.15 0.36-0.15h1.46q0.23 0 0.36 0.15 0.14 0.15 0.14 0.37c0 0 0 19.16 0.01 19.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m283.59 362.75q0 0.44-0.48 0.44h-1.62q-0.2 0-0.3-0.13-0.11-0.12-0.16-0.29l-1.8-6.35h-7.15l-1.76 6.35q-0.06 0.17-0.2 0.29-0.13 0.13-0.3 0.13h-1.62q-0.47 0-0.47-0.44 0-0.14 0.02-0.19l5.1-17.97q0.16-0.63 0.48-1.04 0.32-0.41 0.71-0.63 0.38-0.24 0.81-0.33 0.43-0.09 0.81-0.1 0.39 0 0.8 0.08 0.41 0.08 0.8 0.32 0.38 0.24 0.71 0.64 0.32 0.4 0.48 1.03l5.1 18q0.05 0.05 0.04 0.19zm-7.4-17.58q-0.13-0.5-0.53-0.5-0.41 0-0.55 0.5l-2.51 9.08h6.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300.01 357.53q0 1.74-0.65 2.87-0.65 1.13-1.76 1.79-1.12 0.66-2.58 0.92-1.46 0.26-3.06 0.26-1.37 0-2.54-0.06-1.16-0.06-1.95-0.19-0.48-0.06-0.7-0.27-0.21-0.22-0.21-0.75v-18.38q0-0.95 0.88-1.02 0.69-0.09 1.86-0.15 1.18-0.07 2.53-0.07 1.65 0 3.12 0.25 1.47 0.25 2.57 0.86 1.1 0.61 1.75 1.63 0.65 1.01 0.65 2.6v0.44q0 1.55-0.77 2.66-0.78 1.11-2.17 1.67 1.42 0.49 2.25 1.68 0.81 1.18 0.81 2.79v0.47zm-2.62-9.71q0-0.99-0.39-1.61-0.41-0.62-1.13-0.98-0.73-0.36-1.76-0.48-1.02-0.12-2.29-0.13-0.72 0-1.44 0.03-0.72 0.03-1.3 0.05v6.85h4.25q1.19 0 1.97-0.26 0.79-0.25 1.26-0.72 0.48-0.45 0.65-1.05 0.18-0.59 0.18-1.26zm0.11 9.24q0-0.69-0.2-1.32-0.18-0.64-0.67-1.12-0.48-0.48-1.29-0.77-0.79-0.29-2.01-0.29h-4.25v7.59q0.7 0.03 1.42 0.07 0.73 0.04 1.45 0.04 1.28-0.01 2.31-0.16 1.03-0.16 1.75-0.58 0.72-0.41 1.11-1.13 0.38-0.72 0.39-1.85c0 0 0-0.48-0.01-0.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.51 354.8q0 2.2-0.59 3.84-0.6 1.63-1.69 2.68-1.08 1.05-2.63 1.56-1.54 0.51-3.45 0.51-0.8 0-1.56-0.03-0.76-0.03-1.44-0.07-0.67-0.05-1.2-0.08-0.53-0.04-0.83-0.1-0.58-0.09-0.58-0.69v-18.96q0.01-0.6 0.58-0.69 0.3-0.06 0.83-0.1 0.52-0.05 1.2-0.08 0.68-0.04 1.44-0.07 0.76-0.03 1.56-0.03 1.91 0 3.45 0.5 1.55 0.49 2.63 1.56 1.09 1.06 1.69 2.68 0.59 1.62 0.59 3.85zm-2.51-3.73q0-1.88-0.46-3.12-0.45-1.25-1.24-1.97-0.79-0.73-1.85-1.03-1.07-0.3-2.31-0.3-0.97 0-1.67 0.01-0.7 0.01-1.39 0.07v16.45q0.64 0.06 1.38 0.06h1.68q1.24 0 2.31-0.3 1.06-0.3 1.85-1.05 0.79-0.75 1.24-1.97 0.46-1.23 0.46-3.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335.28 355.74q0 3.94-1.86 5.8-1.87 1.85-5.2 1.85-3.37 0-5.22-1.85-1.85-1.85-1.85-5.8v-12.53q0-0.22 0.15-0.37 0.16-0.15 0.38-0.15h1.49q0.21 0 0.37 0.15 0.15 0.15 0.15 0.37v12.53q0 1.32 0.22 2.36 0.22 1.04 0.76 1.73 0.54 0.69 1.39 1.05 0.86 0.36 2.15 0.36 1.27 0 2.14-0.36 0.86-0.36 1.4-1.05 0.54-0.69 0.76-1.71 0.21-1.02 0.22-2.37v-12.53q0-0.22 0.15-0.37 0.15-0.15 0.37-0.15h1.49q0.22 0 0.37 0.15 0.16 0.16 0.16 0.37v12.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m351.04 362.75q0 0.13-0.07 0.25-0.07 0.11-0.21 0.14-0.55 0.09-1.99 0.17-1.44 0.08-3.4 0.08-1.11 0-2.17-0.17-1.06-0.16-1.89-0.7-0.84-0.54-1.33-1.54-0.49-1.01-0.49-2.72v-15.01q0-0.22 0.16-0.39 0.17-0.17 0.39-0.17h1.4q0.22 0 0.39 0.17 0.17 0.17 0.17 0.39v15.01q0 0.8 0.12 1.34 0.12 0.54 0.48 0.88 0.35 0.35 1.02 0.5 0.67 0.15 1.76 0.15h5.33q0.31 0 0.3 0.33v1.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m368.2 362.75q0 0.44-0.47 0.44h-1.62q-0.2 0-0.3-0.13-0.11-0.12-0.17-0.29l-1.79-6.35h-7.15l-1.77 6.35q-0.05 0.17-0.19 0.29-0.14 0.13-0.3 0.13h-1.63q-0.47 0-0.47-0.44 0-0.14 0.03-0.19l5.1-17.97q0.16-0.63 0.48-1.04 0.31-0.41 0.7-0.63 0.39-0.24 0.82-0.33 0.42-0.09 0.81-0.1 0.38 0 0.8 0.08 0.42 0.08 0.8 0.32 0.38 0.24 0.71 0.64 0.31 0.4 0.48 1.03l5.1 18q0.04 0.05 0.03 0.19zm-7.39-17.58q-0.14-0.5-0.53-0.5-0.42 0-0.55 0.5l-2.51 9.08h6.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m384.02 362.69q0 0.22-0.16 0.36-0.17 0.14-0.39 0.14h-10.63q-1.32 0-1.81-0.39-0.48-0.38-0.48-1.49 0-0.35 0.1-0.83 0.1-0.47 0.32-0.77l9.88-14.38q0.08-0.11 0.08-0.22-0.01-0.19-0.28-0.19h-9.17q-0.22 0-0.39-0.12-0.16-0.12-0.16-0.35v-1.3q0-0.22 0.16-0.34 0.17-0.13 0.39-0.13h9.83q1.15 0 1.75 0.35 0.6 0.35 0.6 1.47 0 0.38-0.11 0.86-0.11 0.47-0.33 0.77l-9.86 14.38q-0.09 0.13-0.08 0.25 0 0.17 0.28 0.17h9.9q0.22 0 0.39 0.12 0.16 0.12 0.16 0.35v1.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m390.43 362.64q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.52q-0.22 0-0.35-0.17-0.15-0.17-0.14-0.39v-19.43q0-0.22 0.14-0.37 0.14-0.15 0.35-0.15h1.52q0.22 0 0.36 0.15 0.14 0.16 0.14 0.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407.86 362.69q0 0.22-0.16 0.36-0.17 0.14-0.39 0.14h-10.63q-1.32 0-1.81-0.39-0.48-0.38-0.48-1.49 0-0.35 0.1-0.83 0.1-0.47 0.32-0.77l9.88-14.38q0.08-0.11 0.08-0.22 0-0.19-0.28-0.19h-9.17q-0.22 0-0.39-0.12-0.16-0.12-0.16-0.35v-1.3q0.01-0.22 0.16-0.34 0.17-0.13 0.39-0.13h9.83q1.15 0 1.75 0.35 0.6 0.35 0.6 1.47 0 0.38-0.11 0.86-0.1 0.47-0.33 0.77l-9.86 14.38q-0.09 0.13-0.08 0.25 0 0.17 0.28 0.17h9.9q0.23 0 0.39 0.12 0.16 0.12 0.16 0.35c0 0 0 1.29 0.01 1.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432.34 355.74q0 3.94-1.86 5.8-1.86 1.85-5.2 1.85-3.36 0-5.21-1.85-1.85-1.85-1.85-5.8v-12.53q0-0.22 0.16-0.37 0.15-0.15 0.37-0.15h1.49q0.22 0 0.37 0.15 0.16 0.15 0.16 0.37v12.53q0 1.32 0.22 2.36 0.22 1.04 0.75 1.73 0.54 0.69 1.4 1.05 0.86 0.36 2.15 0.36 1.28 0 2.14-0.36 0.87-0.36 1.41-1.05 0.53-0.69 0.75-1.71 0.21-1.02 0.22-2.37v-12.53q0-0.22 0.16-0.37 0.15-0.15 0.37-0.15h1.49q0.22 0 0.37 0.15 0.15 0.16 0.15 0.37c0 0 0 12.52-0.01 12.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m451.02 362.39q0 0.33-0.23 0.57-0.23 0.24-0.57 0.23h-1.72q-0.65 0-0.88-0.44l-8.53-16.2q-0.06-0.08-0.09-0.08-0.03 0-0.02 0.08v16.12q0 0.22-0.14 0.37-0.14 0.15-0.35 0.15h-1.44q-0.23 0-0.36-0.06-0.14-0.06-0.14-0.27v-19.4q0-0.33 0.24-0.55 0.23-0.22 0.57-0.22h1.52q0.58 0 0.77 0.13 0.19 0.13 0.35 0.43l8.48 16.12 0.06 0.08q0.02 0 0.02-0.08v-16.14q0-0.22 0.14-0.37 0.13-0.15 0.36-0.15h1.46q0.22 0 0.36 0.15 0.13 0.15 0.13 0.37v19.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m458.12 362.64q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.52q-0.22 0-0.35-0.17-0.15-0.17-0.14-0.39v-19.43q-0.01-0.22 0.14-0.37 0.14-0.15 0.35-0.15h1.52q0.23 0 0.36 0.15 0.14 0.16 0.14 0.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m477.36 343.15q0 0.11-0.02 0.17l-5.08 17.97q-0.2 0.67-0.51 1.06-0.31 0.4-0.7 0.63-0.37 0.23-0.8 0.32-0.43 0.08-0.81 0.08-0.39 0-0.8-0.08-0.41-0.08-0.8-0.32-0.38-0.24-0.71-0.63-0.32-0.4-0.51-1.06l-5.11-17.97q-0.02-0.06-0.02-0.17 0-0.22 0.14-0.34 0.14-0.13 0.36-0.13h1.6q0.17 0 0.3 0.13 0.14 0.12 0.19 0.29l4.8 17.58q0.17 0.58 0.56 0.58 0.36 0 0.53-0.58l4.82-17.58q0.06-0.17 0.18-0.29 0.12-0.13 0.29-0.13h1.63q0.47 0 0.47 0.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m491.27 362.86q0 0.13-0.07 0.25-0.08 0.11-0.21 0.14-0.38 0.06-1.05 0.07-0.65 0.01-1.42 0.04-0.76 0.03-1.53 0.03h-1.39q-2.91 0-4.4-1.19-1.47-1.19-1.48-3.95v-10.63q0-2.77 1.48-3.94 1.47-1.19 4.4-1.19 0.62 0 1.35 0l1.52 0.06q0.75 0 1.41 0.06l1.1 0.06q0.14 0.02 0.21 0.14 0.07 0.11 0.07 0.25v1.38q0 0.33-0.3 0.33h-5.33q-1.11 0-1.76 0.15-0.66 0.15-1.03 0.5-0.36 0.34-0.48 0.9-0.12 0.55-0.12 1.32v3.84h8.48q0.22 0 0.39 0.17 0.16 0.16 0.16 0.39v1.05q0 0.22-0.16 0.39-0.16 0.17-0.39 0.17h-8.48v4.64q0 0.8 0.12 1.34 0.13 0.54 0.48 0.88 0.36 0.35 1.03 0.5 0.66 0.15 1.76 0.15h5.33q0.31 0 0.3 0.33c0 0 0 1.37 0.01 1.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m508.96 362.83q0.01 0.36-0.36 0.36h-1.76q-0.24 0-0.4-0.04-0.16-0.04-0.31-0.32l-4.94-8.22h-0.72q-0.68 0-1.31-0.01-0.61-0.01-1.72-0.07v8.11q0.01 0.22-0.14 0.39-0.14 0.17-0.35 0.17h-1.49q-0.22 0-0.36-0.17-0.13-0.17-0.13-0.39v-19.32q0-0.3 0.13-0.43 0.15-0.12 0.53-0.18 0.45-0.06 1.03-0.1 0.59-0.04 1.25-0.07 0.65-0.03 1.31-0.04 0.65-0.01 1.26-0.01 1.63 0 3.05 0.3 1.41 0.3 2.45 0.99 1.03 0.69 1.63 1.82 0.59 1.13 0.59 2.82v0.19q0 1.16-0.32 2.08-0.32 0.93-0.89 1.61-0.59 0.69-1.38 1.16-0.8 0.47-1.74 0.72l5.02 8.39q0.07 0.16 0.07 0.26zm-3.26-14.4q0-2.07-1.32-2.87-1.33-0.8-3.92-0.8h-0.75q-0.4 0.01-0.84 0.01-0.43 0.01-0.81 0.03-0.39 0.01-0.64 0.04v7.56q0.92 0.03 1.74 0.04 0.82 0.01 1.3 0.01 1.28 0 2.25-0.18 0.99-0.18 1.64-0.62 0.66-0.45 1.01-1.17 0.34-0.74 0.34-1.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m523.83 357.86q0 0.99-0.3 1.99-0.31 0.99-1.07 1.78-0.75 0.79-2.08 1.27-1.32 0.48-3.36 0.48-1.47 0-2.57-0.12-1.1-0.12-2.01-0.26-0.36-0.05-0.44-0.17-0.08-0.11-0.08-0.33v-1.1q0-0.22 0.14-0.33 0.13-0.11 0.33-0.11h0.08q0.46 0.06 1.07 0.08 0.59 0.03 1.2 0.06l1.21 0.03q0.6 0 1.07 0 1.25 0 2.06-0.23 0.81-0.24 1.28-0.66 0.46-0.43 0.66-1.04 0.18-0.61 0.19-1.32 0-0.53-0.16-0.95-0.17-0.43-0.55-0.84-0.38-0.41-1.03-0.87-0.63-0.46-1.57-1.03l-2.68-1.63q-1.9-1.16-2.86-2.33-0.95-1.17-0.95-2.83 0-2.51 1.72-3.7 1.71-1.19 4.88-1.19 0.62 0 1.29 0.03 0.68 0.03 1.32 0.07 0.65 0.05 1.23 0.11 0.59 0.07 0.96 0.13 0.48 0.08 0.48 0.47v1.19q0 0.44-0.48 0.44h-0.05q-0.91-0.06-2.22-0.11-1.32-0.06-2.53-0.06-2.16 0-3.1 0.55-0.95 0.55-0.95 2.07 0 0.97 0.71 1.68 0.73 0.72 2.29 1.66l2.54 1.52q1.19 0.72 2.01 1.38 0.84 0.66 1.35 1.33 0.53 0.66 0.75 1.38 0.22 0.68 0.22 1.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m530.15 362.64q0 0.22-0.14 0.39-0.13 0.17-0.36 0.17h-1.52q-0.22 0-0.35-0.17-0.14-0.17-0.14-0.39v-19.43q0-0.22 0.14-0.37 0.14-0.15 0.35-0.15h1.52q0.23 0 0.36 0.15 0.14 0.16 0.14 0.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.89 344.4q0.01 0.44-0.53 0.44h-5.37v17.8q0 0.22-0.14 0.39-0.14 0.17-0.36 0.17h-1.52q-0.22 0-0.36-0.17-0.13-0.17-0.13-0.39v-17.8h-5.38q-0.22 0-0.39-0.11-0.17-0.1-0.17-0.33v-1.21q0-0.23 0.17-0.36 0.17-0.14 0.39-0.14h13.27q0.53 0 0.53 0.5c0 0 0 1.21-0.01 1.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m564.02 343.07q0 0.14-0.08 0.3l-4.28 9.6q-0.37 0.83-0.75 1.24-0.36 0.41-0.74 0.58v7.84q0 0.22-0.14 0.39-0.13 0.18-0.36 0.17h-1.52q-0.22 0-0.36-0.17-0.13-0.16-0.13-0.39v-7.84q-0.39-0.13-0.75-0.57-0.36-0.42-0.75-1.26l-4.25-9.6q-0.08-0.17-0.08-0.3 0-0.39 0.47-0.39h1.68q0.14 0 0.3 0.13 0.14 0.12 0.21 0.26l3.81 8.94q0.22 0.47 0.36 0.59 0.13 0.12 0.27 0.12 0.15 0 0.28-0.12 0.13-0.12 0.36-0.59l3.83-8.94q0.06-0.14 0.18-0.26 0.12-0.12 0.29-0.13h1.69q0.46 0.01 0.46 0.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m781.72 65.59c22.53 18.72 37.13 45.27 40.87 74.32q0.49 3.83 0.49 7.71v114.36h-7.17v-113.9q0-4.14-0.57-8.26c-3.71-26.86-17.32-51.36-38.16-68.7-16.83-13.55-35.46-24.71-55.35-33.17-19.89 8.46-38.51 19.62-55.35 33.17-22.16 18.45-36.09 44.94-38.73 73.65v117.22h-7.17v-117.54c2.73-30.75 17.62-59.14 41.36-78.87 18.16-14.62 38.33-26.54 59.9-35.39 21.57 8.85 41.74 20.77 59.88 35.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m804.68 141.86q0.39 2.97 0.39 5.95v114.18h-3.58v-113.94q0-3.1-0.42-6.16c-3.2-23.28-14.97-44.53-33.02-59.58-14.16-11.39-29.68-20.98-46.2-28.56-16.52 7.58-32.04 17.17-46.2 28.56-18.05 15.05-29.82 36.3-33.02 59.58q-0.42 3.06-0.42 6.16v113.94h-3.58v-114.18q0-2.99 0.39-5.95c3.23-24.35 15.49-46.6 34.36-62.33 14.83-11.93 31.12-21.91 48.47-29.72 17.35 7.81 33.64 17.79 48.47 29.72 18.86 15.73 31.13 37.98 34.36 62.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m790.62 147.76v114.23h-1.79v-114.11q0-2.01-0.27-4.01c-2.7-20.21-12.88-38.68-28.53-51.77-11.8-9.48-24.61-17.64-38.18-24.33-13.58 6.69-26.38 14.85-38.18 24.33-15.64 13.08-25.82 31.55-28.53 51.77q-0.27 2-0.27 4.01v114.12h-1.79v-114.23q0-1.98 0.26-3.94c2.73-20.74 13.15-39.69 29.2-53.11 12.13-9.75 25.32-18.11 39.31-24.94 13.99 6.83 27.17 15.19 39.31 24.94 16.05 13.42 26.47 32.37 29.2 53.11q0.25 1.96 0.26 3.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m777.97 147.61v114.38h-0.9v-114.33q0-0.98-0.13-1.94c-2.25-17.38-10.95-33.27-24.37-44.53-9.59-7.68-19.87-14.45-30.72-20.21-10.85 5.76-21.14 12.52-30.72 20.21-13.42 11.27-22.12 27.16-24.37 44.53q-0.13 0.96-0.13 1.94v114.33h-0.9v-114.38q0-0.97 0.12-1.93c2.27-17.63 11.09-33.76 24.7-45.18 9.76-7.82 20.23-14.69 31.29-20.53 11.06 5.83 21.54 12.71 31.29 20.53 13.61 11.43 22.43 27.55 24.7 45.18q0.12 0.96 0.14 1.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g59",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m846.13 302.51v39.42h-177.03v-64.59h14.36v50.29h10.92v-50.29h14.3v25.17h61.74v25.12h10.92v-25.12h14.35v25.12h10.87v-25.12h14.35v25.12h10.87v-25.12zm-90.02 14.51h-47.44v10.61h47.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m719.75 277.32h126.38v14.34h-126.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g61",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m658.23 277.34v64.59h-39.58v-50.29h-10.87v50.29h-14.35v-64.59zm-14.36 14.3h-10.87v35.99h10.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m593.42 352.51h252.71v14.34h-252.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 94,
    y1: 450,
    x2: 774.9,
    y2: -84.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m607.76 261.99h-14.34v-115.84q0-3.21 0.34-6.4c3.9-36.59 21.94-70.2 50.27-93.68 22.76-18.36 48.39-32.86 75.85-42.91 27.46 10.05 53.09 24.55 75.85 42.91 28.33 23.48 46.37 57.09 50.27 93.68q0.34 3.18 0.34 6.4v115.84h-14.34v-115.04q0-3.55-0.41-7.06c-3.8-32.32-19.89-61.94-44.93-82.73-20.15-16.23-42.67-29.28-66.78-38.68-24.11 9.4-46.63 22.44-66.78 38.68-25.04 20.79-41.13 50.41-44.93 82.73q-0.41 3.51-0.41 7.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 91.1,
    y1: 450.9,
    x2: 774.2,
    y2: -85.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#447975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#487f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53908a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#64aca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75c6bb"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t\t.s3 { fill: url(#g4) } \n\t\t.s4 { fill: url(#g5) } \n\t\t.s5 { fill: url(#g6) } \n\t\t.s6 { fill: url(#g7) } \n\t\t.s7 { fill: url(#g8) } \n\t\t.s8 { fill: url(#g9) } \n\t\t.s9 { fill: url(#g10) } \n\t\t.s10 { fill: url(#g11) } \n\t\t.s11 { fill: url(#g12) } \n\t\t.s12 { fill: url(#g13) } \n\t\t.s13 { fill: url(#g14) } \n\t\t.s14 { fill: url(#g15) } \n\t\t.s15 { fill: url(#g16) } \n\t\t.s16 { fill: url(#g17) } \n\t\t.s17 { fill: url(#g18) } \n\t\t.s18 { fill: url(#g19) } \n\t\t.s19 { fill: url(#g20) } \n\t\t.s20 { fill: url(#g21) } \n\t\t.s21 { fill: url(#g22) } \n\t\t.s22 { fill: url(#g23) } \n\t\t.s23 { fill: url(#g24) } \n\t\t.s24 { fill: url(#g25) } \n\t\t.s25 { fill: url(#g26) } \n\t\t.s26 { fill: url(#g27) } \n\t\t.s27 { fill: url(#g28) } \n\t\t.s28 { fill: url(#g29) } \n\t\t.s29 { fill: url(#g30) } \n\t\t.s30 { fill: url(#g31) } \n\t\t.s31 { fill: url(#g32) } \n\t\t.s32 { fill: url(#g33) } \n\t\t.s33 { fill: url(#g34) } \n\t\t.s34 { fill: url(#g35) } \n\t\t.s35 { fill: url(#g36) } \n\t\t.s36 { fill: url(#g37) } \n\t\t.s37 { fill: url(#g38) } \n\t\t.s38 { fill: url(#g39) } \n\t\t.s39 { fill: url(#g40) } \n\t\t.s40 { fill: url(#g41) } \n\t\t.s41 { fill: url(#g42) } \n\t\t.s42 { fill: url(#g43) } \n\t\t.s43 { fill: url(#g44) } \n\t\t.s44 { fill: url(#g45) } \n\t\t.s45 { fill: url(#g46) } \n\t\t.s46 { fill: url(#g47) } \n\t\t.s47 { fill: url(#g48) } \n\t\t.s48 { fill: url(#g49) } \n\t\t.s49 { fill: url(#g50) } \n\t\t.s50 { fill: url(#g51) } \n\t\t.s51 { fill: url(#g52) } \n\t\t.s52 { fill: url(#g53) } \n\t\t.s53 { fill: url(#g54) } \n\t\t.s54 { fill: url(#g55) } \n\t\t.s55 { fill: url(#g56) } \n\t\t.s56 { fill: url(#g57) } \n\t\t.s57 { fill: url(#g58) } \n\t\t.s58 { fill: url(#g59) } \n\t\t.s59 { fill: url(#g60) } \n\t\t.s60 { fill: url(#g61) } \n\t\t.s61 { fill: url(#g62) } \n\t\t.s62 { fill: url(#g63) } \n\t\t.s63 { fill: url(#g64) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m13.7 3.1h832.4v363.7h-832.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s49",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s50",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s54",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s61",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s62",
    d: "m17.3 3.1h828.8v363.7h-828.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m13.7 3.1h832.4v363.7h-832.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsaUlogo);
export default __webpack_public_path__ + "static/media/PSAU logo.9f3f4b04a209a8c39777355e2c3b049a.svg";
export { ForwardRef as ReactComponent };